import { UpcomingAssessment } from "@store/locationsSlice";
import { AssessmentBox } from "../AssessmentBox";

export const LeftSide = ({ assessments, handleSelectExaminee }: LeftSideProps): JSX.Element => {
    return (
        <div className="column">
            <div className="mx-6" style={{ maxHeight: "120vh", overflow: "auto" }}>
                {assessments.map((x, idx) => {
                    return (
                        <div key={`${x.id}-${idx}`}>
                            <AssessmentBox
                                assessment={x}
                                isFirst={idx === 0}
                                isLast={idx === assessments.length - 1}
                                onSelected={() => handleSelectExaminee(x)}
                                lastDate
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

interface LeftSideProps {
    assessments: UpcomingAssessment[];
    handleSelectExaminee: (x: UpcomingAssessment) => void;
}
